import React, { useCallback, useEffect } from "react";
import InfoPopup from "../InfoPopup";

export default function ToastItem({ item, dismiss }) {
  const close = useCallback(() => dismiss(item.id), [dismiss, item.id]);
  useEffect(() => {
    if (!item.confirmation) return;
    const previous = document.activeElement;
    return () => {
      if (previous?.isConnected) previous.focus();
    };
  }, [item.confirmation]);
  return (
    <InfoPopup
      title={item.message}
      trigger={1}
      variant={item.variant}
      stacked
      onClose={close}
      role={item.confirmation ? "alertdialog" : undefined}
      onKeyDown={(event) => {
        if (item.confirmation && event.key === "Escape") {
          event.stopPropagation();
          close();
        }
      }}
    >
      {item.confirmation && (
        <div className="d-flex flex-wrap gap-2 mt-3">
          <button
            autoFocus
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={close}
          >
            {item.cancelLabel}
          </button>
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={() => dismiss(item.id, true)}
          >
            {item.acceptLabel}
          </button>
        </div>
      )}
    </InfoPopup>
  );
}
